import type { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import { Lock } from '@ui/uikit/components/icons/mono/Lock';

type Props = ComponentPropsWithoutRef<'button'> & {
  isLoading?: boolean;
  variant?: 'primary' | 'secondary';
  locked?: boolean;
};

export const ListItemButton = ({
  isLoading,
  locked = false,
  variant = 'primary',
  className,
  ...props
}: Props) => {
  return (
    <button
      disabled={locked}
      className={classNames(
        `msq-btn msq-btn-${locked ? 'secondary' : variant} msq-btn-md max-sm:w-full`,
        isLoading && 'msq-btn-loading',
        className,
      )}
      {...props}
    >
      {locked ? <Lock className="icon-xs" /> : props.children}
    </button>
  );
};
